var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.225,
    height: 12.225,
    viewBox: "0 0 12.225 12.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M15.725,9.8a5.226,5.226,0,0,1-.561,2.37A5.3,5.3,0,0,1,10.424,15.1a5.226,5.226,0,0,1-2.37-.561L4.5,15.724,5.685,12.17A5.226,5.226,0,0,1,5.124,9.8,5.3,5.3,0,0,1,8.054,5.061a5.226,5.226,0,0,1,2.37-.561h.312a5.288,5.288,0,0,1,4.989,4.989Z",
    transform: "translate(-4 -4)",
    fill: "none",
    stroke: "#716f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.1e4cbe5ee6d47ee971b4bea9144302a7.svg";
export { ForwardRef as ReactComponent };